import { styled } from '@defa/defa-component-library';

export const PhoneNumberContainer = styled.div`
    display: grid;
    /* A 1fr track is minmax(auto, 1fr), and that auto floor keeps the country
       column at least as wide as its own content — which is what makes the
       noWrap on the Dropdown enough to stop the value wrapping onto a second
       line and running under its floating label. */
    grid-template-columns: 1fr 2fr;
    gap: ${({ theme }) => theme.spacing(2)};

    /* By here that floor has taken most of the row and the number itself is
       down to ~100px. Two full-width fields beat two cramped ones. */
    @media (max-width: 360px) {
        grid-template-columns: 1fr;
    }
`;
